// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input_otr {
	position: relative;
	padding-top: 9px;
	margin-bottom: 10px !important;
}

.input_otr .label_text {
	position: absolute;
	top: 0;
	left: 10px;
	z-index: 2;
	font-size: 12px;
	line-height: 18px;
	color: var(--gray-opacity-50);
	background-color: var(--white-color);
	letter-spacing: 0.00938em;
	padding: 0 8px;
	font-weight: 500;
	font-family: Verdana, sans-serif;
	border: 1px solid transparent;
}

.input_otr:focus-within .label_text {
	color: var(--blue-input-border);
}

.label_text.error {
	color: red !important;
}

.error_message {
	color: red !important;
	font-family: "Poppins", sans-serif;
	letter-spacing: 0.00938em;
	font-size: 11px;
	margin-left: 10px;
}

.input_otr .theme_input {
	padding: 14px 14px 12px 14px;
	font-family: Verdana, sans-serif;
	font-weight: none;
}

.input_otr .theme_input:hover {
	border: 1px solid var(--black-opacity-40) !important;
}

.input_otr .theme_input input {
	font-size: 16px;
	height: 24px;
	font-family: Verdana, sans-serif;
	transition: border 0.3s ease;
}

.input_otr .theme_input:hover {
	border: 1px solid var(--black-opacity-40) !important;
}

.input_otr .theme_input .ant-input-prefix {
    margin-right: 20px;
}

.input_otr .theme_input svg {
	width: 20px;
	height: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/General/Input/Input.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,8BAA8B;AAC/B;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,UAAU;CACV,UAAU;CACV,eAAe;CACf,iBAAiB;CACjB,6BAA6B;CAC7B,oCAAoC;CACpC,yBAAyB;CACzB,cAAc;CACd,gBAAgB;CAChB,gCAAgC;CAChC,6BAA6B;AAC9B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,kCAAkC;CAClC,yBAAyB;CACzB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,4BAA4B;CAC5B,gCAAgC;CAChC,iBAAiB;AAClB;;AAEA;CACC,oDAAoD;AACrD;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,gCAAgC;CAChC,4BAA4B;AAC7B;;AAEA;CACC,oDAAoD;AACrD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;CACC,WAAW;CACX,YAAY;AACb","sourcesContent":[".input_otr {\n\tposition: relative;\n\tpadding-top: 9px;\n\tmargin-bottom: 10px !important;\n}\n\n.input_otr .label_text {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 10px;\n\tz-index: 2;\n\tfont-size: 12px;\n\tline-height: 18px;\n\tcolor: var(--gray-opacity-50);\n\tbackground-color: var(--white-color);\n\tletter-spacing: 0.00938em;\n\tpadding: 0 8px;\n\tfont-weight: 500;\n\tfont-family: Verdana, sans-serif;\n\tborder: 1px solid transparent;\n}\n\n.input_otr:focus-within .label_text {\n\tcolor: var(--blue-input-border);\n}\n\n.label_text.error {\n\tcolor: red !important;\n}\n\n.error_message {\n\tcolor: red !important;\n\tfont-family: \"Poppins\", sans-serif;\n\tletter-spacing: 0.00938em;\n\tfont-size: 11px;\n\tmargin-left: 10px;\n}\n\n.input_otr .theme_input {\n\tpadding: 14px 14px 12px 14px;\n\tfont-family: Verdana, sans-serif;\n\tfont-weight: none;\n}\n\n.input_otr .theme_input:hover {\n\tborder: 1px solid var(--black-opacity-40) !important;\n}\n\n.input_otr .theme_input input {\n\tfont-size: 16px;\n\theight: 24px;\n\tfont-family: Verdana, sans-serif;\n\ttransition: border 0.3s ease;\n}\n\n.input_otr .theme_input:hover {\n\tborder: 1px solid var(--black-opacity-40) !important;\n}\n\n.input_otr .theme_input .ant-input-prefix {\n    margin-right: 20px;\n}\n\n.input_otr .theme_input svg {\n\twidth: 20px;\n\theight: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
